<template>
  <div>
    <div v-if="goodsInfoData" class="detail-box">
      <div class="img-box">
        <div class="box">
          <img :src="img" alt="" />
        </div>
        <!-- 小图 -->
        <div class="small">
          <div
            class="small-list"
            style="display: flex; justify-content: center"
          >
            <div
              v-for="(item, index) in goodsInfoData.images"
              :key="index"
              @mouseenter="changeCurrent(`${fileWebSite}/${item}`)"
            >
              <img :src="`${fileWebSite}/${item}`" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="goods-detail">
        <div class="goods-detail-title">{{ goodsInfoData.title }}</div>
        <div class="goods-detail-note">
          <p style="color: rgba(0, 0, 0, 0.7); font-size: 14px">
            {{ goodsInfoData.note }}
          </p>
        </div>
        <el-divider></el-divider>
        <div class="goods-detail-form">
          <div class="goods-detail-form__item">
            <div class="goods-detail-form__label">
              <label>商品规格</label>
            </div>
            <div class="goods-detail-form__controls">
              <div class="cloudapp-product-sku-picker">
                <button
                  v-for="spec in goodsInfoData.goodsSpecDtos"
                  :key="spec.name"
                  class="goods-btn"
                  :class="{ 'is-selected': spec.id === goodsInfoData.id }"
                  type="button"
                  role="radio"
                  @click="getGoods(spec.id)"
                >
                  {{ spec.specName }}
                </button>
              </div>
            </div>
          </div>
          <div class="goods-detail-form__item">
            <div class="goods-detail-form__label">
              <label>商品价格</label>
            </div>
            <div class="goods-detail-form__controls">
              <div class="goods-detail-form__text">
                <span class="price tea-text-strong">
                  {{ goodsInfoData.price }}
                  <span class="currency-type tea-text"> 元 </span>
                </span>
              </div>
            </div>
          </div>

          <div class="goods-detail-form__item">
            <div class="goods-detail-form__label"></div>
            <div class="goods-detail-form__controls">
              <button class="buy-btn" @click="handleBuy">立即购买</button>
            </div>
          </div>
        </div>
      </div>
      <div class="product-detail-box">
        <div class="product-detail">
          <div class="product-detail-title">商品介绍</div>
          <div v-html="goodsInfoData?.describe" />
        </div>
      </div>
    </div>
    <div
      v-else
      style="
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <el-empty description="暂无商品信息">
        <el-button @click="toTraining" type="primary">返回实训列表</el-button>
      </el-empty>
    </div>
  </div>
</template>

<script>
import { goodsInfoService } from "@/api/goods";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ProductDetail",
  computed: {
    ...mapGetters("oidc", ["oidcIsAuthenticated", "oidcUser"]),
    hasAccess: function () {
      return this.oidcIsAuthenticated;
    },
  },
  data() {
    return {
      fileWebSite: process.env.VUE_APP_FILE_URL,
      goodsInfoData: undefined,
      img: undefined,
    };
  },
  created() {
    this.getGoods();
  },
  methods: {
    ...mapActions("oidc", [
      "signOutOidc",
      "authenticateOidc",
      "authenticateOidcPopup",
    ]),
    getGoods(goodsId) {
      goodsInfoService
        .queryGoodsList({
          id: goodsId,
          platform: this.$route.params && this.$route.params.id,
        })
        .then((res) => {
          if (res) {
            this.goodsInfoData = res;
            this.img = `${process.env.VUE_APP_FILE_URL}/${res?.images[0]}`;
          }
        });
    },

    // 处理小图点击事件
    changeCurrent(url) {
      this.img = url;
    },
    toTraining() {
      this.$router.push("/training");
    },
    handleBuy() {
      if (this.oidcIsAuthenticated) {
        this.addCart()
      } else {
        this.authenticateOidcPopup().then(() => {
          if (this.oidcIsAuthenticated) {
            this.addCart();
          }
        });
      }
    },
    addCart() {
      this.$store.dispatch("cart/addCart", {
        id: this.goodsInfoData.id,
        title: this.goodsInfoData.title,
        price: this.goodsInfoData.price,
        specName: this.goodsInfoData.goodsSpecDtos.find(
          (d) => d.id === this.goodsInfoData.id
        ).specName,
        img: this.goodsInfoData.images[0],
        count: 1,
        platform: this.$route.params && this.$route.params.id,
      });
      this.$router.push("/order/cart");
    },
  },
};
</script>

<style scoped lang="scss">
._magnifier_zoom {
  width: 200px !important;
}

::v-deep #_magnifier_layer {
  width: 200px !important;
  background: red !important;
}

.product-detail-box {
  width: 100%;

  .product-detail {
    width: 1200px;
    margin: 20px auto 0;

    &-title {
      font-size: 24px;
      font-weight: 700;

      padding-bottom: 15px;
    }
  }
}

// .property-box {
//   padding-top: 8px;
//   border-top: 1px solid #e7e7e7;
//   border-bottom: 1px solid #e7e7e7;
// }

.detail-box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  margin-top: 24px;
}

.box {
  width: 500px;
  height: 360px;
  border: 1px solid #ccc;
}

.box > img {
  width: 100%;
  height: 100%;
}

.img {
  width: 1400px;
  z-index: 2;
}

.img-box {
  width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}

.small {
  width: 500px;
  height: 60px;
}

.small-list {
  display: flex;
  margin-top: 10px;
  flex-wrap: wrap;
}

.small-list > div {
  border: 1px solid #ccc;
  // width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 3px;
  cursor: pointer;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  // img {
  //   width: 100%;
  // }
}

.small-list > .active {
  border: 2px solid #006275;
}

.goods-detail {
  width: 700px;
}

.goods-detail-title {
  font-size: 24px;
  color: #0f1111;
  font-weight: 600;
  line-height: 26px;
}

.icon {
  // background-image: url("~@/assets/3-fm1Jbg4IHlyhq.png");
  background-size: 512px 256px;
  background-repeat: no-repeat;
  height: 18px;
  width: 97px;
  display: inline-block;
}

.goods-detail-note {
  display: flex;
  align-items: center;
  margin: 8px 0;
}

// .property {
//   font-size: 14px;
//   margin-bottom: 8px;
// }
// .property > .type {
//   color: #0f1111;
//   font-weight: 700;
//   display: inline-block;
//   width: 100px;
// }

.goods-detail-form {
  display: table;
  font-size: 12px;
  line-height: 1.5;
}

.goods-detail-form__item {
  display: table-row;
}

.goods-detail-form .goods-detail-form__label {
  vertical-align: baseline;
  color: rgba(0, 0, 0, 0.5);
  padding-right: 20px;
  padding-top: calc((30px - 18px) / 2);
  padding-bottom: calc((30px - 18px) / 2);
  width: 1px;
}

.goods-detail-form__label label {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  white-space: nowrap;
  font-size: 12px;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.goods-detail-form__controls {
  color: rgba(0, 0, 0, 0.9);
  word-wrap: break-word;
  word-break: break-word;
  padding-right: 24px;
  width: 100%;
}

.goods-detail-form .goods-detail-form__controls,
.goods-detail-form .goods-detail-form__label {
  display: table-cell;
  vertical-align: top;
  padding-bottom: 16px;
}

.cloudapp-product-sku-picker {
}

.cloudapp-product-sku-picker .goods-btn {
  float: left;
  position: relative;
  margin-left: -1px;
  z-index: 0;
  border-radius: 0;
  border-color: #e6e9ef;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.9);
  margin-bottom: 5px;
  padding: 0 20px;
  margin-right: 0 !important;
}

.cloudapp-product-sku-picker .goods-btn.is-selected {
  z-index: 2;
  border-color: #2196f3;
  background: #fff;
  color: #2196f3;
}

.goods-btn {
  height: 30px;
  min-width: 24px;
  padding: 0 20px;
  // background-color: var(--button-color-bg-solid-default-brand);
  // color: var(--button-color-text-solid-default-brand);
  border: 1px solid #2196f3;
  line-height: calc(30px - 2px);
  text-align: center;
  display: inline-block;
  cursor: pointer;
  outline: 0 none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-decoration: none;
  font-size: 12px;
  vertical-align: middle;
  white-space: nowrap;
  border-radius: 0px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.goods-detail-form__text {
  font-size: 12px;
  vertical-align: middle;
  color: rgba(0, 0, 0, 0.9);
}

.price {
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.tea-text-strong {
  color: rgba(0, 0, 0, 0.9) !important;
}

.currency-type {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.tea-text {
  color: rgba(0, 0, 0, 0.9) !important;
}

.buy-btn {
  display: inline-block;
  height: 40px;
  line-height: 38px;
  padding: 0 16px;
  font-size: 16px;
  color: #000;
  border: 1px solid #d1d7df;
  // background-color: #fff;
  text-align: center;
  transition: all 0.25s;
  box-sizing: border-box;
  width: fit-content;
  cursor: pointer;

  background-color: #2196f3;

  font-size: 14px;
  line-height: 22px;
  border: 1px solid #2196f3;
  color: #fff;
}
</style>
